export const en = {
  poweredByFirst: "Powered By",
  poweredBySecond: "KENKON EVAS",
  name: "Name",
  gender: "Gender",
  age: "Age",
  recordNo: "Med.Record",
  from: "From",
  ward: "Ward",
  examDate: "Exam. Date",
  examTime: "Exam. Time",
  examItem: "Exam. Item",
  applicationDate: "Application Date",
  applicationTime: "Application Time",
  applicationDr: "Application DR",
  reportTime: "Report Time",
  reportDate: "Report Date",
  vs: "VS.",
  examDr: "EXAM. DR.",
  nurse: "Nurse",
  technician: "Technician",
  Sigmoidoscopy: "Sigmoidoscopy Report",
  Colonoscopy: "Colonoscopy Report",
  Gastroscopy: "Gastroscopy Report",
  ColonoscopyCheckNo: "28017C",
  GastroscopyCheckNo: "28016C",

  // ColonCloeanseForm
  indication: "Indication",
  complication: "Complication",
  sedatives: "Sedatives",
  premedication: "Premedication",
  antiPlatelet: "Anti platelet",
  preparationTime: "Preparation Time",
  preparationAgent: "Preparation Agent",
  cleanseLevel: "Cleanse Level(before)",
  cleanseLevelAfter: "Cleanse Level(after)",
  scopeId: "Scope ID",
  washingMachine: "Washing machine",
  informedConsent: "Informed consent",
  insertionTime: "Insertion Time",
  withdrawTime: "Withdrawal Time",
  totalExamTime: "Total Exam",
  proximalColonWithTime: "Proximal Colon Withdrawal Time",
  insertionLevel: "Insertion Level",
  insertionLength: "Insertion Length",
  incompleteStudy: "Incomplete study due to",
  additionalRemarks: "Additional Remarks",

  // Colon finding
  finding: "Finding",
  findings: "Findings",
  lesion: "Lesion",
  summary: "Summary",
  suggestion: "Suggestion",
  other: "Other",
  procedureNote: "Procedure Note",
  procedureImages: "Procedure Images",
  additionalImage: "Additional Image",
  
  http: {
    error: {
      400: "Bad Request",
      401: "Unauthorized",
      403: "Forbidden",
      404: "Not Found",
      405: "Method Not Allowed",
      406: "Not Acceptable",
      408: "Request Timeout",
      500: "Internal Server Error",
      502: "Bad Gateway",
      503: "Service Unavailable",
      504: "Gateway Timeout",
      505: "HTTP Version Not Supported",
      999: "JavaScript Error",
    },
  },
};
